// frontend/src/components/WatchGanttChart.jsx
import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Bar,
  Label,
} from "recharts";
import Typography from '@mui/material/Typography';
import { extractIntervals } from '../utils/watchUtils';

const WatchGanttChart = ({ logs, videoDuration }) => {
  const data = extractIntervals(logs || []).slice().reverse();
  const barHeight = 10;
  const gap = 6;
  const chartHeight = data.length > 0 ? Math.max(80, 40 + data.length * (barHeight + gap)) : 80;

  // X軸のドメインを決定 (videoDuration があればそれを使用、なければデータに基づくかデフォルト)
  const xDomainMax = videoDuration && typeof videoDuration === 'number' && videoDuration > 0 
    ? videoDuration 
    : (data.length > 0 ? Math.max(0, ...data.map(d => (d.offset || 0) + (d.duration || 0))) + 10 : 100);

  if (!logs || logs.length === 0 || data.length === 0) {
    return <Typography variant="body2" color="text.secondary" sx={{p:2, textAlign:'center'}}>視聴区間データがありません。</Typography>;
  }

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 5, right: 30, left: 0, bottom: 25 }}
        barCategoryGap={`${gap}px`}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          type="number"
          domain={[0, Math.ceil(xDomainMax / 10) * 10]} // キリの良い数値にする
          tickCount={Math.min(11, Math.floor(xDomainMax / 60) + 2)} // 60秒ごとの目盛りを意識
          allowDecimals={false}
        >
          <Label 
            value="動画内時間 (秒)" 
            offset={0} // offsetは0のままか、必要に応じて調整
            position="insideBottom" 
            dy={10} // ★ Y方向のオフセット。正の値で下に移動します。10ピクセル下に。値を調整してください。
            // style={{ fontSize: '10px' }} // 必要であればフォントサイズも調整
          />
        </XAxis>
        <YAxis
          type="category"
          dataKey="name"
          width={80}
          tick={{ fontSize: 10 }}
        />
        <Tooltip
          formatter={(value, name, props) => {
            if (name === "duration" && props.payload && typeof props.payload.duration === 'number' && typeof props.payload.offset === 'number') {
              return [`視聴: ${props.payload.duration.toFixed(1)}s (開始: ${props.payload.offset.toFixed(1)}s)`, null];
            }
            return null; 
          }}
          cursor={{fill: 'rgba(200, 200, 200, 0.2)'}}
        />
        <Bar dataKey="offset" stackId="a" fill="transparent" isAnimationActive={false} />
        <Bar
          dataKey="duration"
          stackId="a"
          fill="#76B900"
          barSize={barHeight}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default WatchGanttChart;